import { EditChildcareProviderBaseModel } from "@/models/childcare-provider/enrollment/editChildcareProviderModels";
import { ChildcareProvider } from "@/models/childcare-provider/enrollment/getChildcareProviderModels";
import { ChildcareProviderEnrollmentService } from "@/services/childcare-provider/enrollment/childcareProviderEnrollmentService";
import { Module } from "vuex";

interface ChildcareProviderState {
  childcareProvider: ChildcareProvider | null;
}

const providerModule: Module<ChildcareProviderState, any> = {
  namespaced: true,
  state: {
    childcareProvider: null
  },

  mutations: {
    setProvider(state, childcareProvider: ChildcareProvider) {
      state.childcareProvider = childcareProvider;
    },
    updateProvider(state, updatedFields: Partial<ChildcareProvider>) {
      if (state.childcareProvider) {
        state.childcareProvider = { ...state.childcareProvider, ...updatedFields };
      }
    }
  },

  actions: {
    async fetchProvider({ commit, state }, childcareProviderId: string): Promise<ChildcareProvider> {
      if (state.childcareProvider && state.childcareProvider.id === childcareProviderId) {
        return state.childcareProvider;
      }

      const childcareProvider = await ChildcareProviderEnrollmentService.getChildcareProviderInfoById(childcareProviderId);

      commit("setProvider", childcareProvider);

      return childcareProvider;
    },

    async editChildcareProvider({ commit }, { childcareProviderId, updatedFields}: { childcareProviderId: string; updatedFields: EditChildcareProviderBaseModel }): Promise<ChildcareProvider> {
      const childcareProvider = await ChildcareProviderEnrollmentService.editChildcareProvider(childcareProviderId, updatedFields);

      commit("setProvider", childcareProvider);

      return childcareProvider;
    }
  },

  getters: {
    provider: (state): ChildcareProvider | null => state.childcareProvider
  }
};

export default providerModule;